// Hooks
import useTranslate from "@/hooks/useTranslate/useTranslate";

// Types
import type { I_UseValidate_Return } from "../index";

/** Функция-валидатор для поля "ID Number" */
export default function idNumberLocationZaValidator(value: string): I_UseValidate_Return {
    if (!value) {
        return {
            status: false,
            message: useTranslate("tiw__validation__id_number_required"),
        };
    }

    if (!/^\d{13}$/.test(value)) {
        return {
            status: false,
            message: useTranslate("tiw__validation__id_number_range"),
        };
    }

    return {
        status: true,
        message: useTranslate("tiw__validation__success"),
    };
}
